/* eslint-disable no-console */
import { useEffect } from 'react';

interface Props {
  componentName: string;
  version: string;
}

export const useDeprecateComponent = ({ componentName, version }: Props) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production')
      console.warn(`Warning: ${componentName}:: this component will be deprecated in version: ${version}.`);
  }, [componentName, version]);
};
